import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { SimpleForm, useNotify, useRedirect } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { EditPage } from 'shared/react-admin/Pages/EditPage/EditPage';
import { Referral } from 'types/embedded/referral';

import { ReferralsForm } from './components/ReferralsFrom';

export const ReferralsEdit: React.FC = () => {
  const translate = useTypedTranslate();

  const notify = useNotify();
  const redirect = useRedirect();

  function onSuccess(referral: Referral) {
    notify(
      <>
        Реферал <TypographyBold text={referral.name} /> изменён
      </>,
      { type: 'success' },
    );
    redirect('list', Resources.Referrals);
  }

  function onError(error: any) {
    notify(error.message, { type: 'error' });
  }

  return (
    <EditPage
      listName={translate('app.referrals.title')}
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess, onError }}
      title={translate('app.referrals.editTitle')}
    >
      <SimpleForm sx={{ '&.MuiCardContent-root': { padding: 0 } }} toolbar={false}>
        <ReferralsForm />
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" variant="outlined" />,
            <SaveButtonValidated key="save-button" />,
          ]}
          sx={{ marginTop: 'auto', padding: 0 }}
        />
      </SimpleForm>
    </EditPage>
  );
};
